import script from "./LoadingPlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingPlaceholder.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingPlaceholder.vue?vue&type=style&index=0&id=f368754a&lang=scss"

const __exports__ = script;

export default __exports__